import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EntityServiceError } from '../shared/errors/entity-service.error';

export const VerifyEmailPageActions = createActionGroup({
  source: 'Verify Email Page',
  events: {
    'Resend Email Clicked': props<{ userId: string }>(),
  },
});

export const ResendVerifyEmailEffectActions = createActionGroup({
  source: 'Resend Verify Email Effect',
  events: {
    'Resend Email Succeeded': emptyProps(),
    'Resend Email Errored': props<{ error: EntityServiceError }>(),
  },
});
